module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MinusInCircle_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4,9H4V7h8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MinusInCircle_16.svg
// module id = bQUU
// module chunks = 1